<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dm6953/tc-custom/9781504096232.jpg?1724781543630" alt="This image is the cover for the book Maya Barton Thrillers Books One to Three, Maya Barton"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maya Barton Thrillers Books One to Three, Maya Barton
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of three gripping crime novels from a real-life CSI . . .</b><br/><br/><b><i>Definitely Dead</i></b><br/> Maya Barton has just embarked on her dream job as a scene-of-crime officer, and she’s already facing a tough challenge. When she attends her first dead-persons case, the post-mortem deems it to be non-suspicious and the case is closed. But despite the lack of evidence, she suspects a crime has been committed . . .<br/><br/> “A brilliant novel . . . stunning.” —Lynda La Plante, Edgar Award–winning author of <i>Prime Suspect</i><br/><br/><b><i>Shattered Bones</i></b><br/> How do you catch a killer if you can’t identify the victim? SOCO Maya Barton is called to a canal where a decomposed male body has been discovered. A bank card belonging to Trevor Dawlish is found in the corpses’s pocket, and the name matches that of a missing person. All seems straightforward—until Trevor’s wife phones the police to say that Trevor has returned home . . .<br/><br/><b><i>Flesh and Blood</i></b><br/> Maya Barton is an experienced SOCO—but gathering evidence after the crime’s been committed is one thing, and being targeted for murder is another. Now she must untangle her own dark past to solve her toughest case yet.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Bendelow
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8e55ab2e